import { Box, Heading, Text } from "src/components/UI";

const DirectDebitInformation = () => {
  return (
    <Box
      padding={["16px", "0"]}
      gap={["8px", "24px"]}
      marginBottom={[null, "64px"]}
    >
      <Heading
        fontFamily="Roboto, sans-serif"
        fontSize={["15px", "24px"]}
        fontWeight={["500", "700"]}
        lineHeight={["24px", "28px"]}
        letterSpacing={["unset", "-0.24px"]}
        textAlign={["left", "center"]}
        color={["#404040", "#000000"]}
      >
        Penting Untuk Kamu Ketahui
      </Heading>
      <Box
        as="ul"
        listStyle="initial"
        fontFamily="Roboto, sans-serif"
        paddingLeft={["16px"]}
        fontSize={["13px", "16px"]}
        fontWeight={["500", "400"]}
        lineHeight={["20px", "24px"]}
        letterSpacing={["0.24px"]}
        color={["#676767"]}
        maxWidth={["unset", "688px"]}
        margin={["unset", "0 auto"]}
      >
        <li>
          <Text>
            Pendebitan otomatis dilakukan 3 hari sebelum tanggal jatuh tempo.
          </Text>
        </li>
        <li>
          <Text>
            Pendebitan otomatis dilakukan pada pukul 10.00 dan/atau 19.00.
          </Text>
        </li>
        <li>
          <Text>
            Jika gagal, pendebitan otomatis dilakukan 2 hari sebelum tanggal
            jatuh tempo pada pukul 10.00.
          </Text>
        </li>
        <li>
          <Text>
            Jika masih gagal, pendebitan otomatis akan dilakukan di tanggal
            jatuh tempo pada pukul 10.00.
          </Text>
        </li>
      </Box>
    </Box>
  );
};

export default DirectDebitInformation;
